import React, { useContext, useEffect, useRef, useState } from 'react';
import Checkmark from '../../../assets/images/icons/checkmark.svg';
import Checkbox from '../../Checkbox/Checkbox';
import Caret from '../../../assets/images/icons/caret-right.svg';
import Edit from '../../../assets/images/icons/edit.svg';
import Delete from '../../../assets/images/icons/trash.svg';
import { LocalizationContext } from '../../../context/localizationContext';
import { clubsContext } from '../../../context/clubsContext';
import { notificationContext } from '../../../context/notificationContext';
import APIClient from '../../../helpers/APIClient';
import ClubModal from '../../ClubModal/ClubModal';
import ClubSpecs from './ClubSpecs/ClubSpecs';
import getClubImage from '../../../helpers/ClubImageHelper';
import Styles from './ClubListItem.module.scss';

const ClubListItem = (props) => {
  const {
    club,
    registered,
    updateSelectedClubsList,
    groupItem,
    isTileView,
    selectedAll,
  } = props;
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { registerNewClub, clubItemTxt, modal, notification } =
    localizationState.localization;
  const clubContext = useContext(clubsContext);
  const { dispatch } = clubContext;
  const { notificationState, notificationDispatch } =
    useContext(notificationContext);
  const { addedClubSerial, isOpen } = notificationState;
  const [showBuildSpecs, setShowBuildSpecs] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const editActionsRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(
    club?.registered || selectedAll === 'CHECKED'
  );

  const unregisterClub = () => {
    setIsEditing(false);
    setModalOpen(false);
    if (club?.serialHeaderKey) {
      APIClient.unregisterSerialHeaderKey(
        club?.serialHeaderKey,
        (unregisterStatus) => {
          if (unregisterStatus === 200) {
            notificationDispatch({
              type: 'SET_NOTIFICATION',
              isOpen: true,
              message: notification?.unregisterSuccess,
              icon: 'checkmark',
            });
            APIClient.getAllSerials((status, resp) => {
              if (status === 200) {
                dispatch({ type: 'SET_USER_CLUBS', clubs: resp.data });
              } else {
                notificationDispatch({
                  type: 'SET_NOTIFICATION',
                  isOpen: true,
                  message: notification?.getClubsError,
                  icon: 'error',
                });
              }
            });
          } else {
            notificationDispatch({
              type: 'SET_NOTIFICATION',
              isOpen: true,
              message: notification?.unregisterError,
              icon: 'error',
            });
          }
        }
      );
    }
  };

  const editActionList = [
    {
      label: clubItemTxt?.removeClub,
      action: () => setModalOpen(true),
    },
  ];

  const renderClubs = (clubs) => {
    if (Array.isArray(clubs)) {
      return clubs.toString().replace(/,/g, ', ');
    }
    return clubs;
  };

  const getFormattedDate = (date) => {
    try {
      const year = date.getFullYear();

      let month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : `0${month}`;

      let day = date.getDate().toString();
      day = day.length > 1 ? day : `0${day}`;

      return `${month}/${day}/${year}`;
    } catch {
      return '';
    }
  };

  const getClubItem = (isModalItem) => {
    return (
      <div
        className={`${Styles.item}
      ${isTileView && Styles.tileView}
      ${!registered ? Styles.border : ''}
      ${isChecked && !registered ? Styles.isChecked : ''}
      ${groupItem ? Styles.groupItem : ''}
      ${isModalItem && Styles.modalItem}
      ${!registered && club?.registered && Styles.isRegistered}
      ${
        isOpen &&
        addedClubSerial?.includes(club?.serialNumber) &&
        registered &&
        !isTileView
          ? Styles.newlyAddedClub
          : ''
      }
      `}
      >
        <div className={Styles.itemContent}>
          {!registered && (
            <div className={Styles.checkContainer}>
              <Checkbox
                defaultChecked={club?.registered}
                disabled={club?.registered}
                isChecked={isChecked || selectedAll === 'CHECKED'}
                onclick={(e) => {
                  updateSelectedClubsList(club, !isChecked);
                  setIsChecked(!isChecked);
                }}
              />
            </div>
          )}
          <div className={Styles.itemContentLeft}>
            <div className={Styles.clubImageContainer}>
              <img
                className={`${Styles.clubImage} ${
                  club?.moreDetailsLink ? Styles.cursor : ''
                }`}
                onClick={() =>
                  club?.moreDetailsLink !== '' &&
                  window.open(club?.moreDetailsLink, '__blank')
                }
                src={
                  club?.imagePath !== ''
                    ? club?.imagePath
                    : getClubImage(club?.productFormatted)
                }
                alt="club"
                onError={({ currentTarget }) => {
                  if (
                    currentTarget.src !== getClubImage(club?.productFormatted)
                  ) {
                    currentTarget.onerror = null;
                    currentTarget.src = getClubImage(club?.productFormatted);
                  }
                }}
              />
            </div>
            <div className={Styles.itemContentRight}>
              <div className={Styles.descriptionAndRegistrationDate}>
                <div className={Styles.description}>
                  <div className={Styles.product}>{club?.productFormatted}</div>
                  <div className={Styles.model}>{club?.modelFormatted}</div>
                  <div className={Styles.club}>
                    {club?.productFormatted === 'DRIVERS'
                      ? club?.attributes?.colorcode
                      : club?.club && renderClubs(club.club)}
                  </div>
                  <div className={Styles.serialLabel}>
                    {clubItemTxt?.serialNumber}:
                    <span className={Styles.serial}>{club?.serialNumber}</span>
                  </div>
                </div>
                {registered && !isModalItem && !isTileView && (
                  <div className={Styles.registeredLabel}>
                    <img
                      className={Styles.checkmark}
                      src={Checkmark}
                      alt={'check'}
                    />
                    <div className={Styles.textAndDate}>
                      {clubItemTxt?.registeredLbl}
                    </div>
                  </div>
                )}
              </div>
              <div>
                {!isTileView && !isModalItem && (
                  <>
                    <div className={Styles.originalBuildSpecsBtn}>
                      <div onClick={() => setShowBuildSpecs(!showBuildSpecs)}>
                        {clubItemTxt?.originalBuildSpecs}
                        <img
                          className={`${Styles.caret} ${
                            showBuildSpecs ? Styles.rotate : ''
                          }`}
                          src={Caret}
                          alt={'caret'}
                        />
                      </div>
                    </div>
                    {showBuildSpecs && (
                      <div>
                        <ClubSpecs
                          clubItem={club}
                          getFormattedDate={getFormattedDate}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          {!isTileView && registered && !isModalItem && (
            <div className={Styles.editActionsWrapper} ref={editActionsRef}>
              <div
                className={Styles.editButton}
                onClick={() => setIsEditing(!isEditing)}
              >
                <img className={Styles.editIcon} src={Edit} alt="edit" />
              </div>
              {(isEditing || modalOpen) && (
                <div className={Styles.editActions}>
                  {editActionList?.map((item, i) => {
                    return (
                      <button
                        key={i}
                        className={Styles.editActionBtn}
                        type="button"
                        onClick={() => item.action && item.action()}
                      >
                        <img src={Delete} alt="delete" />
                        {item.label}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const handleClickOutside = (e) => {
    if (editActionsRef.current && !editActionsRef.current.contains(e.target)) {
      setIsEditing(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  useEffect(() => {
    if (selectedAll === 'CHECKED') {
      setIsChecked(true);
    } else if (selectedAll === 'UNCHECKED' && !club?.registered) {
      setIsChecked(false);
    }
  }, [selectedAll]);

  return (
    <div>
      {club && getClubItem()}
      <ClubModal
        isOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalMessage={modal?.deleteClub}
        okText={modal?.removeClub}
        okClick={unregisterClub}
      >
        {club && getClubItem(true)}
      </ClubModal>
    </div>
  );
};

export default ClubListItem;
